module.exports = __webpack_public_path__ + "img/astral_10.7486b898.svg";